import ApiClient from "./ApiClient";
import SchoolYear from "../models/school-year/SchoolYear";

export default class SchoolYearApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "school-years/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getSchoolYears() {
    const schoolYears = await this.apiClient.get(this.urlPrefix);

    return <SchoolYear[]>schoolYears;
  }

  async getSchoolYearsToCurrentMonth() {
    const schoolYears = await this.apiClient.get(
      this.urlPrefix + "to-current-month"
    );

    return <SchoolYear[]>schoolYears;
  }

  async getSchoolYearsFromToCurrentMonthForYear(
    dateFrom: Date,
    schoolYearId: number
  ) {
    const schoolYears = await this.apiClient.get(
      this.urlPrefix +
        `from-to-current-month-for-year?dateFrom=${dateFrom.toJSON()}&schoolYearId=${schoolYearId}`
    );

    return <SchoolYear[]>schoolYears;
  }
}
